import { type FC, useId } from 'react'
import { useIntl } from 'react-intl'

import { FormControl, FormHelperText, Input } from 'base-ui'

import { useMarketplacePartnerRegisterPageContext } from '../../marketplacePartnerRegisterPageContext'

export const MarketplacePartnerRegisterPageFormBrandTextArea: FC = () => {
  const intl = useIntl()
  const { formState } = useMarketplacePartnerRegisterPageContext()
  const fieldId = useId()
  const initRowsCount = 5
  formState.use()

  return (
    <div>
      <FormControl
        {...formState.makeInputProps('brandsTextArea', {
          validateOnBlur: true,
        })}
        error={!formState.model.validator.isPropertyValid('brandsTextArea')}
        onChange={(event): void => {
          formState.setValue(
            event.target.value,
            formState.model,
            'brandsTextArea',
          )
        }}
        required
      >
        <Input
          id={fieldId}
          multiline
          placeholder={intl.formatMessage({
            id: 'marketplacePartnerRegisterPage.brands.input.textarea.placeholder',
          })}
          rows={initRowsCount}
          slotProps={{
            input: {
              className: 'overflow-y-auto',
              'data-qa-id': 'sellerForm-brandsTextarea',
              style: { maxHeight: '16rem' },
            },
          }}
        />
      </FormControl>
      {formState.model.validator.getFirstErrorFor('brandsTextArea') && (
        <FormHelperText data-qa-id="global-MessageForm-brands-error-msg" error>
          {formState.model.validator.getFirstErrorFor('brandsTextArea')}
        </FormHelperText>
      )}
    </div>
  )
}
